import { Link } from "react-router-dom";
import { certificationStrings } from "../../../components/StringBundle";
import { formatDateSafe } from "../../common";
import { CheckBox } from "../../../components/CheckBox";
import { filterTableSorter } from "../../../components/TableCustomSort";
import FileDownload from "../../../assets/images/file_download.svg";
import { useGlobalListStyles } from "../../../components/globalStyles";

const certificationGridColumns = certificationStrings.grid;
const certificationStatusString = certificationStrings.forms;

export const statusList = [
  { value: "CE-ST-1", label: certificationStatusString.certifications },
  { value: "CE-ST-2", label: certificationStatusString.expired },
]

// map each column id to its data type
const certificationColumnTypes = {
  issued_date: "date",
  expiry_date: "date",
  alert_initation_date1: "date",
  alert_initation_date2: "date",
  expired: "checkbox",
  doc_name: "icon",
  type_of_certification: "text",
  certification_name: "text",
  location: "text",
  status: "text",
  attachments_count: "number"
};

export const GetCertificationGridColumns = (handleDownload) => {
  const globalClasses = useGlobalListStyles();
  const result = [];
  for (const id in certificationGridColumns) {
    const label = certificationGridColumns[id];
    const colType = certificationColumnTypes[id] || "text";
    let colDef;
    if (id === "type_of_certification") {
      colDef = {
        title: label,
        dataIndex: id,
        key: id,
        type: "text",
        render: (text, record) => {
          const certificationId = record?.certification_id;
          return <Link to={`/certification/${encodeURIComponent(certificationId)}/view`}>{text}</Link>;
        },
      };
    } else if (colType === "date") {
      colDef = {
        title: label,
        dataIndex: id,
        key: id,
        type: colType,
        width: "15%",
        sorter: filterTableSorter(id, 'date', 'YYYY-MM-DD'),
        render: formatDateSafe,
      };
    } else if (colType === "checkbox") {
      colDef = {
        title: label,
        dataIndex: id,
        key: id,
        type: colType,
        render: (text, record) => (
          <CheckBox
            checked={Boolean(record.expired)}
            disabled
          />
        ),
      };
    } else if (colType === "icon") {
      colDef = {
        title: label,
        dataIndex: id,
        key: id,
        type: colType,
        disableFilter: true,
        render: (text, record) => {
          return (
            <div onClick={() => handleDownload(record, text)}>
            <img src={FileDownload} className={globalClasses.sortHeader}  />
            </div>
          );
        }
      };
    } else {
      colDef = {
        title: label,
        dataIndex: id,
        key: id,
        type: colType
      };
    }
    if (colDef) result.push(colDef);
  }
  return result;
};